var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordcloudMultipleColorImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40911",
    "data-name": "Group 40911",
    transform: "translate(-3923 -3446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143304",
    "data-name": "Rectangle 143304",
    d: "M2,0H6A0,0,0,0,1,6,0V6A0,0,0,0,1,6,6H0A0,0,0,0,1,0,6V2A2,2,0,0,1,2,0Z",
    transform: "translate(3923 3446)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143306",
    "data-name": "Rectangle 143306",
    d: "M0,0H6A0,0,0,0,1,6,0V6A0,0,0,0,1,6,6H2A2,2,0,0,1,0,4V0A0,0,0,0,1,0,0Z",
    transform: "translate(3923 3453)",
    fill: "#ff4dca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143307",
    "data-name": "Rectangle 143307",
    d: "M0,0H6A0,0,0,0,1,6,0V4A2,2,0,0,1,4,6H0A0,0,0,0,1,0,6V0A0,0,0,0,1,0,0Z",
    transform: "translate(3930 3453)",
    fill: "#20d983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_143305",
    "data-name": "Rectangle 143305",
    d: "M0,0H4A2,2,0,0,1,6,2V6A0,0,0,0,1,6,6H0A0,0,0,0,1,0,6V0A0,0,0,0,1,0,0Z",
    transform: "translate(3930 3446)",
    fill: "#ac52ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordcloudMultipleColorImg);
export default __webpack_public_path__ + "static/media/wordcloud_multiple_color_img.1c6c2d59b6ecb1266eaa12a54c387a69.svg";
export { ForwardRef as ReactComponent };